import classNames from 'classnames'
import { ReactElement } from 'react'

export function FeedDivider({ text, className }: { text: string; className?: string }): ReactElement {
  return (
    <div
      className={classNames(
        `flex items-center before:w-full before:border before:border-default after:w-full after:border after:border-default`,
        className,
      )}
    >
      <span className="shrink-0 rounded-md border border-default bg-surface px-3 py-1 text-ui-xs leading-4 text-subtle shadow-elevation-1">
        {text}
      </span>
    </div>
  )
}
